export default __webpack_public_path__ + "static/media/Sheet-Metal-Enclosure2-scaled.1ff6ae89.webp";